module.exports = __webpack_public_path__ + "static/media/mayo.40638878.png";